package io.horion.auth.domain.models

data class Language(val code: String, val label: String, val flag: String)
